import { FetchOurOtherServiceByType } from "api";
import { InnerBanner } from "container/InnerpageBanner";
import { Crumbs } from "molecules/Breadcrumbs";
import { DetailBox } from "molecules/DetailBox";
import { SectionBorder } from "molecules/SectionBorder";
import Divider from "molecules/SimpleBorder/Divider";
import { TitleHeading } from "molecules/TitleHeading";
import { Accordion, AccordionTab } from "primereact/accordion";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const OtherServices = () => {
  const [mastersData, setMastersData] = useState(null);

  const fetchMastersData = async () => {
    try {
      const data = await FetchOurOtherServiceByType("other-services");
      console.log("other-services", data);
      setMastersData(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchMastersData();
  }, []);

  const {
    data: ourServiceData,
    loading: loadingourService,
    error: errorourService,
  } = useSelector((state) => state.otherService);

  // console.log(ourServiceData,"aaa")
  const [data, setData] = useState(null);

  useEffect(() => {
    if (ourServiceData && !loadingourService && !errorourService) {
      // Once data is available and loading is false, set the first object of the array
      setData(ourServiceData[0]);
    }
  }, [ourServiceData, loadingourService, errorourService]); // Dependency array ensures this effect runs when these values change

  // Show loading or error messages
  if (loadingourService) {
    return <div>Loading...</div>;
  }

  if (errorourService) {
    return <div>Error fetching data: {errorourService}</div>;
  }

  // Render the component when data is available
  if (!data) {
    return <div>No data available.</div>;
  }

  const clientdata = [
    {
      id: 1,
      header: data?.heading_2_sub_1,
      description: data?.heading_2_sub_1_text,
      image_path: "/media/home_slider/client_box.png",
      type: "pre-investment",
    },
    {
      id: 2,
      header: data?.heading_2_sub_2,
      description: data?.heading_2_sub_2_text,
      image_path: "/media/home_slider/client_box.png",
      type: "pre-investment",
    },
    {
      id: 3,
      header: data?.heading_2_sub_3,
      description: data?.heading_2_sub_3_text,
      image_path: "/media/home_slider/client_box.png",
      type: "pre-investment",
    },
    {
      id: 4,
      header: data?.heading_2_sub_4,
      description: data?.heading_2_sub_4_text,
      image_path: "/media/home_slider/client_box.png",
      type: "pre-investment",
    },
    {
      id: 5,
      header: data?.heading_2_sub_5,
      description: data?.heading_2_sub_5_text,
      image_path: "/media/home_slider/client_box.png",
      type: "pre-investment",
    },
    {
      id: 6,
      header: data?.heading_3_sub_1,
      description: data?.heading_3_sub_1_text,
      image_path: "/media/home_slider/client_box.png",
      type: "pre-investment2",
    },
    {
      id: 7,
      header: data?.heading_3_sub_2,
      description: data?.heading_3_sub_2_text,
      image_path: "/media/home_slider/client_box.png",
      type: "pre-investment2",
    },
    {
      id: 8,
      header: data?.heading_3_sub_3,
      description: data?.heading_3_sub_3_text,
      image_path: "/media/home_slider/client_box.png",
      type: "pre-investment2",
    },
    {
      id: 9,
      header: data?.heading_3_sub_4,
      description: data?.heading_3_sub_4_text,
      image_path: "/media/home_slider/client_box.png",
      type: "pre-investment2",
    },
    {
      id: 10,
      header: data?.heading_4_sub_1,
      description: data?.heading_4_sub_1_text,
      image_path: "/media/home_slider/client_box.png",
      type: "value-Services",
    },
    {
      id: 11,
      header: data?.heading_4_sub_2,
      description: data?.heading_4_sub_2_text,
      image_path: "/media/home_slider/client_box.png",
      type: "value-Services",
    },
    {
      id: 12,
      header: data?.heading_4_sub_3,
      description: data?.heading_3_sub_4_text,
      image_path: "/media/home_slider/client_box.png",
      type: "value-Services",
    },
  ];

  return (
    <div className="backgroundThm mobileContainer">
      <div className="container pl-0 pr-0">
        <Crumbs />
        <InnerBanner
          bannertext={data?.main_header_text}
          innertitle="Other Services"
          bannerimg={data?.banner_image}
        />
      </div>
      <div className="container pl-0 pr-0">
        <section className="section-padding1 px-0">
          <div className="container   pl-0 pr-0">
            <div className="grid section-title pr-0">
              <div className="lg:col-4 md:col-5 sm:col-12 pl-0 pr-0  py-0 ">
                <TitleHeading title={data?.heading_1} className="mt-0 " />
              </div>
              <div className="lg:col-8 md:col-7 sm:col-12 pr-0">
                <div className="grid">
                  <div className="lg:col-12 md:col-12 sm:col-12 p-0 ">
                    <DetailBox
                      details={data?.heading_1_text}
                      className=" text-justify mt-0 mb-3 p-0"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container  pl-0 pr-0 pt-2">
            {/* <SectionBorder /> */}
            <Divider />
          </div>
        </section>
      </div>

      {mastersData?.map((item, index) => {
        return (
          <div className="container pl-0 pr-0">
            <section className="section-padding1 px-0 pt-0">
              <div className="container  pl-0 pr-0">
                <div className="grid">
                  <div className="lg:col-12 md:col-12 sm:col-12 p-0">
                    <div className="grid">
                      <div className="lg:col-4 md:col-5 sm:col-12 p-0">
                        <TitleHeading
                          title={item?.title}
                          className="mt-0 mb-3"
                        />
                      </div>
                      <div className="lg:col-8 md:col-7 sm:col-12 pr-0">
                        <DetailBox
                          details={item?.description}
                          className="text-justify mb-4"
                        />

                        <Accordion multiple activeIndex={[-1]}>
                          {item?.master_data.map((item2, index) => (
                            <AccordionTab
                              header={item2.master_data_title}
                              key={index}
                            >
                              <DetailBox
                                details={item2.master_data_description}
                                className="m-0 px-3 pb-3"
                              />
                            </AccordionTab>
                          ))}
                        </Accordion>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container pl-0 pr-0">
                <SectionBorder />
              </div>
            </section>
          </div>
        );
      })}
      {/* <div className="container pl-0 pr-0">
        <section className="section-padding1 px-0 pt-0">
          <div className="container  pl-0 pr-0">
            <div className="grid">
              <div className="lg:col-12 md:col-12 sm:col-12 p-0">
                <div className="grid">
                  <div className="lg:col-4 md:col-5 sm:col-12 p-0">
                    <TitleHeading
                      title={data?.heading_2}
                      className="mt-0 mb-3"
                    />
                  </div>
                  <div className="lg:col-8 md:col-7 sm:col-12 pr-0">
                    <DetailBox
                      details={data?.heading_2_text}
                      className="text-justify mb-4"
                    />

                    <Accordion multiple activeIndex={[-1]}>
                      {clientdata.map((item, index) =>
                        item.type == "pre-investment" ? (
                          <AccordionTab header={item.header} key={index}>
                            <DetailBox
                              details={item.description}
                              className="m-0 px-3 pb-3"
                            />
                          </AccordionTab>
                        ) : (
                          "Loding Data"
                        )
                      )}
                    </Accordion>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container pl-0 pr-0">
            <SectionBorder />
          </div>
        </section>
      </div>

      <div className="container pl-0 pr-0">
        <section className="section-padding1 px-0 pt-0">
          <div className="container  pl-0 pr-0">
            <div className="grid">
              <div className="lg:col-12 md:col-12 sm:col-12 p-0">
                <div className="grid">
                  <div className="lg:col-4 md:col-5 sm:col-12 p-0">
                    <TitleHeading
                      title={data?.heading_3}
                      className="mt-0 mb-3"
                    />
                  </div>
                  <div className="lg:col-8 md:col-7 sm:col-12 pr-0">
                    <DetailBox
                      details={data?.heading_3_text}
                      className="text-justify mb-4"
                    />

                    <Accordion multiple activeIndex={[1]}>
                      {clientdata.map((item, index) =>
                        item.type == "pre-investment2" ? (
                          <AccordionTab header={item.header} key={index}>
                            <DetailBox
                              details={item.description}
                              className="m-0 px-3 pb-3"
                            />
                          </AccordionTab>
                        ) : (
                          <h5>Loding Data</h5>
                        )
                      )}
                    </Accordion>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container pl-0 pr-0">
            <SectionBorder />
          </div>
        </section>
      </div>

      <div className="container pl-0 pr-0">
        <section className="section-padding1 pb-1 px-0 pt-0">
          <div className="container   pl-0 pr-0">
            <div className="grid">
              <div className="lg:col-12 md:col-12 sm:col-12 p-0 ">
                <div className="grid">
                  <div className="lg:col-4 md:col-5 sm:col-12 p-0">
                    <TitleHeading
                      title={data?.heading_4}
                      className="mt-0 mb-3"
                    />
                  </div>
                  <div className="lg:col-8 md:col-7 sm:col-12 pr-0">
                    <DetailBox
                      details={data?.heading_4_text}
                      className="text-justify mb-4"
                    />

                    <Accordion multiple activeIndex={[1]}>
                      {clientdata.map((item, index) =>
                        item.type == "value-Services" ? (
                          <AccordionTab
                            header={item.header}
                            className="AccordionTabHeader"
                            key={index}
                          >
                            <DetailBox
                              details={item.description}
                              className="m-0 px-3 pb-3"
                            />
                          </AccordionTab>
                        ) : (
                          <h5>Loding Data</h5>
                        )
                      )}
                    </Accordion>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> */}
    </div>
  );
};
